import ServiceError from '../../../core/errors/ServiceError';
import parserContextual from './parserContextual';
import parserPOCPlaylist from './parserPOCPlaylist';

export default function parserPlaylistFactory(config, jsonToParsed) {
  switch (config.service) {
    case 'CONTEXTUAL':
      return parserContextual(config.targetId, jsonToParsed);
    case 'POC':
      return parserPOCPlaylist(config.targetId, jsonToParsed);
    default:
      throw new ServiceError('No service to parser', '05002');
  }
}
